import * as React from 'react';

import * as FormStyle from '../../../../Common/Styles/form.styled';
import { EntityTypeSelectionPreview } from '../EntityTypeSelectionPreview';
import { MachineLearningExperimentWizardStep } from './MachineLearningExperimentWizard';
import {
  MachineLearningExperimentWizardContext,
  MachineLearningExperimentWizardContextProps,
} from './MachineLearningExperimentWizardContext';

export function MachineLearningExperimentReviewWizardStep(): React.ReactElement {
  const { experiment, completedSteps, setCompletedSteps } =
    React.useContext<MachineLearningExperimentWizardContextProps>(MachineLearningExperimentWizardContext);
  React.useEffect(() => {
    if (
      completedSteps.indexOf(MachineLearningExperimentWizardStep.MODEL) > -1 &&
      completedSteps.indexOf(MachineLearningExperimentWizardStep.REVIEW) === -1
    ) {
      setCompletedSteps([...completedSteps, MachineLearningExperimentWizardStep.REVIEW]);
    }
  }, [completedSteps, experiment.type, setCompletedSteps]);

  return (
    <FormStyle.MinimumForm>
      <FormStyle.InputGroup>
        <h2>Review</h2>
      </FormStyle.InputGroup>

      <EntityTypeSelectionPreview data={experiment} />
    </FormStyle.MinimumForm>
  );
}
